import { GROUP_PREFIX, RESERVATION_PREFIX } from './constants';
import { GroupsAndReservationsDialogFormValues } from './schema';

export const normalizeGroupsAndReservationsFormValues = (
    values: GroupsAndReservationsDialogFormValues
): {
    reservationIds: string[];
    reservationGroupIds: string[];
} => {
    const reservationIdsToExclude = new Set(values.reservationsWithGroupChecked ?? []);

    return values.groupsAndReservations.reduce<{
        reservationIds: string[];
        reservationGroupIds: string[];
    }>(
        (acc, groupOrReservationId) => {
            if (groupOrReservationId.startsWith(GROUP_PREFIX)) {
                acc.reservationGroupIds.push(groupOrReservationId.replace(GROUP_PREFIX, ''));
            } else if (groupOrReservationId.startsWith(RESERVATION_PREFIX)) {
                if (!reservationIdsToExclude.has(groupOrReservationId)) {
                    acc.reservationIds.push(groupOrReservationId.replace(RESERVATION_PREFIX, ''));
                }
            }
            return acc;
        },
        { reservationIds: [], reservationGroupIds: [] }
    );
};
